<template>
    <k-row class="jd-expert-item-good ta-center">
        <k-col span="6"  class="jd-expert-item-good-w">
            <div class="jd-expert-item-good-num">{{wcount || 0}}</div>
            <div class="jd-expert-item-good-desc cl-desc">上周鉴定</div>
        </k-col>
        <k-col span="6"  class="jd-expert-item-good-w">
            <div class="jd-expert-item-good-num">{{through || "-"}}<span v-if="through" class="fts-sm">年</span></div>
            <div class="jd-expert-item-good-desc cl-desc">鉴定经验</div>
        </k-col>
        <k-col span="6"  class="jd-expert-item-good-w">
            <div class="jd-expert-item-good-num"><span class="fts-sm" v-if="slow">&yen;</span>{{(slow) || "-"}}</div>
            <div class="jd-expert-item-good-desc cl-desc">普通鉴定</div>
        </k-col>
        <k-col span="6"  class="jd-expert-item-good-w">
            <div class="jd-expert-item-good-num"><span class="fts-sm" v-if="fast">&yen;</span>{{(fast) || "-"}}</div>
            <div class="jd-expert-item-good-desc cl-desc">极速鉴定</div>
        </k-col>
    </k-row>
</template>

<script>
    export default {
        name: "appraiser-good",
        props : ["wcount", "through", "slow", "fast"]
    }
</script>

<style scoped>
    .jd-expert-item-good-num {
        font-size: 0.34rem;
    }
    .jd-expert-item-good-desc {
        font-size: 0.2rem;
    }
</style>